<template>
    <div>
        <ConfirmationModal
            v-if="canReject && modal.isShowModal"
            :showModal.sync="modal.isShowModal"
            question="Confirmer l'abandon de la demande de renouvellement de dispense ?"
            closeButtonText="Annuler"
            confirmButtonText="Renoncer"
            :isSwapButtons="true"
            @confirmApprove="abortConfirm"
        />

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-create d-lg-inline-block img-desktop-employee" />
            <div class="no-autorized__img" />
            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2 alert-container" />
                </div>
            </section>

            <section class="content content-without-sidebar">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-9 employee-form-request-content">
                            <div class="request-title">
                                <h1>Demande de dispense d'affiliation</h1>
                            </div>
                            <div class="containerIntroEmployee">
                                <ul class="instructionsEmployee">
                                    <li>Vérifiez les données pré-remplies dans le formulaire</li>
                                    <li v-if="!isGeneralInformationLocked">Corrigez si vous relevez des erreurs</li>
                                    <li>Complétez les champs obligatoires</li>
                                    <li>Joindre la ou les pièce(s) justificative(s) si nécessaire</li>
                                    <li>Validez la demande</li>
                                </ul>
                                <p v-html="exemptionFormHeadingText" />
                                <p v-if="canReject">
                                    Si vous ne souhaitez pas renouveler votre dispense, cliquez sur le bouton ci-contre
                                    <button class="btn btn-danger ms-1 abort-exemption" @click.prevent="abort">
                                        <span>Renoncer</span>
                                    </button>
                                </p>
                                <div v-if="enterpriseSettings && enterpriseSettings.sector === 'public'">
                                  <hr class="browser-default" />
                                  <p>
                                    En formulant la présente demande de dispense, vous reconnaissez avoir été informé que :
                                  </p>
                                  <p/>
                                  <ul class="browser-default">
                                    <li>
                                      vous renoncez à la participation financière de votre employeur au titre de votre
                                      cotisation (soit 50 % de la cotisation d'équilibre du contrat collectif, hors
                                      cotisations additionnelles),
                                    </li>
                                    <li>
                                      vous renoncez, en cas de cessation de la relation de travail avec votre employeur, au
                                      maintien de vos garanties et de votre adhésion au contrat collectif (pendant une durée
                                      maximale de 12 mois),
                                    </li>
                                    <li>
                                      vous pouvez à tout moment revenir sur cette dispense et demander à adhérer au contrat
                                      collectif (dans ce cas, aucune majoration de cotisation ne vous sera appliquée).
                                    </li>
                                  </ul>
                                </div>
                            </div>
                            <div class="required-field-text">Champs obligatoires</div>
                            <div class="form-group">
                                <form
                                    name="exemption"
                                    method="post"
                                    enctype="multipart/form-data"
                                    novalidate="novalidate"
                                    class="needs-validation"
                                >
                                    <!-- Civility -->
                                    <label class="required-field-asterisks required" for="exemption_civility">
                                        Civilité
                                    </label>
                                    <select
                                        id="exemption_civility"
                                        required="required"
                                        class="form-control"
                                        :class="{ 'is-invalid': $v.formData.civility.$error }"
                                        @change="delayTouch($v.formData.civility)"
                                        v-model="formData.civility"
                                        :disabled="isGeneralInformationLocked && !civilityInitiallyEmpty"
                                    >
                                        <option value="">-- Choisir --</option>
                                        <option
                                            v-for="civility in civilities"
                                            :key="civility.id"
                                            :value="civility.label"
                                        >{{ civility.label }}</option>
                                    </select>
                                    <FormError
                                        error="Veuillez renseigner la civilité"
                                        v-if="!$v.formData.civility.required && $v.formData.civility.$dirty"
                                    />
                                    <FormError
                                        error="La civilité ne doit pas dépasser 20 caractères"
                                        v-if="!$v.formData.civility.maxLength && $v.formData.civility.$dirty"
                                    />
                                    <!-- Civility -->

                                    <!-- First Name -->
                                    <label class="required-field-asterisks required"  for="exemption_first_name">
                                        Prénom
                                    </label>
                                    <input
                                        type="text"
                                        id="exemption_first_name"
                                        required="required"
                                        class="form-control form-control-lg"
                                        aria-describedby="first-name-error"
                                        placeholder="Prénom"
                                        :class="{ 'is-invalid': $v.formData.firstName.$error }"
                                        @input="delayTouch($v.formData.firstName)"
                                        v-model="formData.firstName"
                                        :readonly="isGeneralInformationLocked"
                                    >
                                    <FormError
                                        error="Veuillez renseigner le prénom"
                                        v-if="$v.formData.firstName.$error"
                                    />
                                    <!-- First Name -->

                                    <!-- Last Name -->
                                    <label class="required-field-asterisks required" for="exemption_last_name">
                                        Nom
                                    </label>
                                    <input
                                        type="text"
                                        id="exemption_last_name"
                                        required="required"
                                        class="form-control form-control-lg"
                                        aria-describedby="last-name-error"
                                        placeholder="Nom"
                                        :class="{ 'is-invalid': $v.formData.lastName.$error }"
                                        @input="delayTouch($v.formData.lastName)"
                                        v-model="formData.lastName"
                                        :readonly="isGeneralInformationLocked"
                                    >
                                    <FormError
                                        error="Veuillez renseigner le nom"
                                        v-if="$v.formData.lastName.$error"
                                    />
                                    <!-- Last Name -->

                                    <!-- Birth Name -->
                                    <label for="exemption_birth_name">
                                        Nom de naissance
                                    </label>
                                    <input
                                        type="text"
                                        id="exemption_birth_name"
                                        name="exemption[birth_name]"
                                        class="form-control form-control-lg"
                                        placeholder="Nom de naissance"
                                        v-model="formData.birthName"
                                        :readonly="isGeneralInformationLocked"
                                    >
                                    <!-- Birth Name -->

                                    <!-- Email -->
                                    <label class="required-field-asterisks required" for="exemption_email">
                                        Email professionnel
                                    </label>
                                    <input
                                        type="email"
                                        id="exemption_email"
                                        name="exemption[email]"
                                        required="required"
                                        class="form-control form-control-lg"
                                        placeholder="Email"
                                        :class="{ 'is-invalid': $v.formData.email.$error }"
                                        @input="delayTouch($v.formData.email)"
                                        v-model="formData.email"
                                        :readonly="isGeneralInformationLocked"
                                    >
                                    <FormError
                                        error="Format de l'email incorrect"
                                        v-if="!$v.formData.email.email && $v.formData.email.$dirty"
                                    />
                                    <FormError
                                        error="Veuillez renseigner l’email"
                                        v-if="!$v.formData.email.required && $v.formData.email.$dirty"
                                    />
                                    <!-- Email -->

                                    <!-- Phone Number -->
                                    <!-- TODO::remove v-if when yousign will be available for exemption -->
                                    <div class="form-group" v-if="false">
                                        <label for="phone" ref="phoneNumber">
                                            Téléphone
                                        </label>
                                        <div class="input-group" >
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i class="fas fa-phone"></i>
                                                </span>
                                            </div>
                                            <masked-input
                                                v-if="!isGeneralInformationLocked"
                                                type="tel"
                                                mask="\+\33 1 11 11 11 11"
                                                id="phone"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.formData.phoneNumber.$error }"
                                                @input="delayTouch($v.formData.phoneNumber)"
                                                v-model="formData.phoneNumber"
                                            />
                                            <input
                                                v-else
                                                type="tel"
                                                id="phone"
                                                class="form-control"
                                                :value="formData.phoneNumber"
                                                readonly
                                            />
                                        </div>
                                        <FormError
                                            error="Le numéro de téléphone doit contenir 11 chiffres"
                                            v-if="!$v.formData.phoneNumber.phoneLength && $v.formData.phoneNumber.$dirty"
                                        />
                                        <FormError
                                            error="Le numéro de téléphone doit  respecter le format suivant : 6 50 67 89 23"
                                            v-if="!$v.formData.phoneNumber.phoneFormat && $v.formData.phoneNumber.$dirty"
                                        />
                                    </div>
                                    <!-- Phone Number -->

                                    <!-- Birth Date -->
                                    <div class="form-group">
                                        <label class="required-field-asterisks required" for="birthDate">
                                            Date de naissance
                                        </label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i class="far fa-calendar-alt"></i>
                                                </span>
                                            </div>
                                            <masked-input
                                                v-if="!isGeneralInformationLocked"
                                                type="text"
                                                id="birthDate"
                                                mask="11/11/1111"
                                                class="form-control float-right"
                                                :class="{ 'is-invalid': $v.formData.birthDate.$error }"
                                                @input="maskedDelayTouch($v.formData.birthDate)"
                                                v-model="formData.birthDate"
                                            />
                                            <input
                                                v-else
                                                type="text"
                                                id="birthDate"
                                                class="form-control float-right"
                                                :value="formData.birthDate"
                                                readonly
                                            />
                                        </div>
                                        <FormError
                                            error="Format de date incorrect"
                                            v-if="!$v.formData.birthDate.validDate && $v.formData.birthDate.$dirty"
                                        />
                                        <FormError
                                            error="Veuillez renseigner la date "
                                            v-if="!$v.formData.birthDate.required && $v.formData.birthDate.$dirty"
                                        />
                                        <FormError
                                            error="L'année indiquée n'est pas correcte"
                                            v-if="!$v.formData.birthDate.isValidDateYear && $v.formData.birthDate.$dirty"
                                        />
                                    </div>
                                    <!-- Birth Date -->

                                    <!-- Employee number -->
                                    <div class="form-group" v-if="handledFields.employeeNumber">
                                        <label for="exemption_birth_name">
                                            N° matricule
                                        </label>
                                        <input
                                            type="text"
                                            id="exemption_employee_number"
                                            name="exemption[employee_number]"
                                            class="form-control form-control-lg"
                                            placeholder="N° matricule"
                                            v-model="formData.employeeNumber"
                                            :readonly="isGeneralInformationLocked"
                                        >
                                    </div>
                                    <!-- Employee number -->

                                    <!-- Exemption start date -->
                                    <div class="form-group">
                                        <label class="required-field-asterisks required" for="startDate">
                                          Date de début de la dispense
                                        </label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i class="far fa-calendar-alt"></i>
                                                </span>
                                            </div>
                                            <masked-input
                                                v-if="startDateInitiallyEmpty || handledFields.allowEditStartDate"
                                                type="text"
                                                id="startDate"
                                                mask="11/11/1111"
                                                class="form-control float-right"
                                                :class="{ 'is-invalid': $v.formData.startDate.$error }"
                                                @input="maskedDelayTouch($v.formData.startDate)"
                                                v-model="formData.startDate"
                                            />
                                            <input
                                                v-else
                                                type="text"
                                                id="startDate"
                                                class="form-control float-right"
                                                :value="formData.startDate"
                                                readonly
                                            />
                                        </div>
                                        <FormError
                                            error="Veuillez renseigner la date de début"
                                            v-if="!$v.formData.startDate.required && $v.formData.startDate.$dirty"
                                        />
                                        <FormError
                                            error="Veuillez renseigner une date comprise entre aujourd’hui moins un an et aujourd’hui plus un an"
                                            v-if="!$v.formData.startDate.isValidDateRange"
                                        />
                                        <FormError
                                            error="Format de date incorrect"
                                            v-if="!$v.formData.startDate.validDate && $v.formData.startDate.$dirty"
                                        />
                                    </div>
                                    <!-- Exemption start date -->

                                    <!-- Reason -->
                                    <div id="reason_group" class="form-group box-body">
                                        <label class="required-field-asterisks">
                                            Motif
                                        </label>
                                        <div
                                            class="icheck-primary radioNewResquestReasons"
                                            v-for="reason in reasons"
                                            :key="reason.code"
                                        >
                                            <input
                                                type="radio"
                                                :id="reason.code"
                                                :value="reason.id"
                                                name="reason"
                                                v-model="formData.exemptionReason.reasonId"
                                                class="form-check-input"
                                            >
                                            <label class="form-check-label" :for="reason.code">
                                                <span class="radioLabel">{{ reason.titleEmployee }}</span>
                                            </label>
                                        </div>
                                    </div>
                                    <!-- Reason -->

                                    <!-- Reason Documents -->
                                    <ReasonDocuments
                                        :chosenReason.sync="chosenReason"
                                        :exemptionReason.sync="formData.exemptionReason"
                                        :expirationDate.sync="formData.exemptionReason.expirationDate"
                                        :exemptionStartDate="formData.startDate"
                                        :validationGroup="'employee-edit'"
                                        :enterpriseSettings="enterpriseSettings"
                                        ref="reasonDocuments"
                                    />
                                    <!-- Reason Documents -->
                                </form>
                            </div>
                        </div>

                        <div class="input-group col-md-9">
                            <div class="mx-sm-auto">
                                <button
                                    class="btn btn-primary btn-lg savepdf"
                                    :disabled="isButtonDisabled()"
                                    @click.prevent="confirm"
                                >
                                    <span>Confirmer</span>
                                    <span
                                        v-if="confirmIsLoading"
                                        class="spinner-border spinner-border-sm ml-2"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import FormError from '../../components/FormError';
    import ValidationDelayTouch from '../../mixins/validationDelayTouch';
    import MaskedInput from 'vue-masked-input';
    import ExemptionManager from '../../service/manager/exemptionManager';
    import ReasonDocuments from '../../components/ReasonDocuments';
    import { email, required, maxLength } from 'vuelidate/lib/validators';
    import { errorMessage } from '../../utils/sweet-alert-options';
    import {
        phoneNumberConstraint,
        validDateConstraint,
        phoneNumberFormat,
        isValidDateYearConstraint,
        dateInOneYearRange,
    } from '@/utils/validation';
    import {
        abortExemptionRenew,
        employeeConfirmByAccessToken,

        fetchDueReasonsByAccessToken,
        fetchEnterpriseReasonsByAccessToken,
        fetchExemptionByAccessToken,
        fetchPartialBeneficiariesByAccessToken,
        fetchReasonByIdAndAccessToken,
        fetchReasons,
    } from '@/service/api/exemptions.api';
    import { filterRenewReasons } from '@/utils/utils';
    import { mapGetters } from 'vuex';
    import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';

    export default {
        mixins: [ValidationDelayTouch],
        data() {
            return {
                formData: {
                    civility: '',
                    firstName: '',
                    lastName: '',
                    birthName: '',
                    phoneNumber: '',
                    email: '',
                    birthDate: '',
                    employeeNumber: '',
                    productCode: '01',
                    beneficiaryId: null,
                    exemptionReason: {
                        reasonId: '',
                        documents: [],
                        expirationDate: ''
                    },
                },
                baseReasons: [],
                reasons: [],
                beneficiaries: [],
                chosenReason: null,
                confirmIsLoading: false,
                exemption: null,
                startDateInitiallyEmpty: false,
                civilityInitiallyEmpty: false,
                modal: {
                    isShowModal: false
                },
            };
        },
        computed: {
            ...mapGetters({
                enterpriseSettings: 'enterpriseSettings',
                civilities: 'civilities',
            }),
            handledFields() {
                const {
                    employeeNumberHandled: employeeNumber = false,
                    allowEditStartDate = false,
                } = this.enterpriseSettings || {};
                return { employeeNumber, allowEditStartDate };
            },
            reason() {
                return this.formData.exemptionReason.reasonId;
            },
            accessToken() {
                return this.$route.params.exemptionAccessToken;
            },
            filteredBaseReasons() {
                return this.baseReasons.filter((reason) => {
                    return reason.code !== 'cd7';
                });
            },
            enterpriseUuid() {
                return this.exemption ? this.exemption.enterprise.uuid : null;
            },
            isGeneralInformationLocked() {
                return !this.exemption || this.exemption.courseType === 'token';
            },
            isRenewExemptionForm() {
                return this.exemption && !!this.exemption.previousReason;
            },
            canReject() {
                return this.isRenewExemptionForm;
            },
            exemptionFormHeadingText() {
                if (this.enterpriseSettings && this.enterpriseSettings.exemptionFormHeadingText) {
                    return this.enterpriseSettings.exemptionFormHeadingText;
                }

                return '';
            }
        },
        watch: {
            reason(reasonId) {
                if (!Number.isInteger(reasonId)) {
                    this.chosenReason = null;

                    return;
                }

                this.fetchChosenReason(reasonId);
            },
        },
        async mounted() {
            await this.fetchExemption();
            if (!this.exemption) {
              return;
            }

            await this.$store.dispatch('fetchCivilities');

            this.beneficiaries = await fetchPartialBeneficiariesByAccessToken(this.accessToken);
            await this.fetchBaseReasons(this.enterpriseUuid);
            await this.handleBeneficiaryChange();
        },
        methods: {
            isButtonDisabled() {
                if (!this.$refs.reasonDocuments) {
                    return true;
                }

                return this.$v.$invalid
                    || this.$refs.reasonDocuments.$v.$invalid
                    || this.confirmIsLoading
                ;
            },
            async fetchExemption() {
                try {
                    const { data } = await fetchExemptionByAccessToken(this.accessToken);
                    this.exemption = data;
                    await this.$store.dispatch('setSettingsContext', { enterpriseUuid: data.enterprise.uuid, isPublic: true });
                    this.formData = {
                        ...this.formData,
                        ...await ExemptionManager.createEmployeeEditFormData(data)
                    }
                    this.startDateInitiallyEmpty = !this.formData.startDate;
                    this.civilityInitiallyEmpty = !this.formData.civility;

                    if (data.status === 'aborted') {
                        this.$router.push({ name: 'oops', params: { messageShortCode: 'aborted_exemption' }});
                    }

                    if (data.status === 'validated') {
                        this.$router.push({ name: 'oops', params: { messageShortCode: 'already_validated_exemption' }});
                    }
                } catch (err) {
                    await this.$router.push({ name: 'oops', params: { messageShortCode: 'token_expired' }});
                }
            },
            async fetchChosenReason(id) {
                const { data } = await fetchReasonByIdAndAccessToken(id, this.accessToken);
                this.chosenReason = data;
            },
            async handleBeneficiaryChange() {
                let reasons = [];

                switch (true) {
                    case null != this.exemption.due: {
                        const { data: dueReasons } = await fetchDueReasonsByAccessToken(
                            this.accessToken,
                            this.exemption.due.id,
                            this.enterpriseUuid,
                        );
                        reasons = [...this.filteredBaseReasons, ...dueReasons];
                        break;
                    }
                    case null != this.exemption.enterprise: {
                        const { data: enterpriseReasons } = await fetchEnterpriseReasonsByAccessToken(
                            this.accessToken,
                            this.exemption.enterprise.uuid
                        );

                        // Let cd7 be available only if there is no configured enterprise reasons
                        if (enterpriseReasons.length > 0) {
                            reasons = [...this.filteredBaseReasons, ...enterpriseReasons];
                        } else {
                            reasons = this.baseReasons;
                        }
                    }
                }

                this.reasons = filterRenewReasons(this.exemption, reasons);
            },
            async fetchBaseReasons() {
                let { data } = await fetchReasons({ params: {
                    isOptional: false,
                    enterpriseUuid: this.enterpriseUuid,
                } });
                this.baseReasons = data;
            },
            async abort() {
                this.modal.isShowModal = true;
            },
            async abortConfirm() {
                await abortExemptionRenew(this.accessToken);

                this.$router.push({
                    name: 'success',
                    params: { messageShortCode: 'confirm_exemption_aborted' }
                });
            },
            async confirm() {
                this.confirmIsLoading = true;

                try {
                    const { employeeNumber, ...rest } = this.formData;
                    const { data } = await employeeConfirmByAccessToken(
                        this.accessToken,
                        {
                            ...rest,
                            ...(this.handledFields.employeeNumber && { employeeNumber }),
                        }
                    );

                    if (data.status === 'to_validate') {
                        await this.$router.push({
                            name: 'success',
                            params: { messageShortCode: 'confirm_exemption' }
                        });
                    }

                    this.confirmIsLoading = false;
                } catch ({ response }) {
                    this.confirmIsLoading = false;
                    if (response?.data?.detail) {
                        const message = response.data.detail.replace(/^[\w.[\]]+:\s*/, '');
                        this.$swal({ title: message, ...errorMessage });
                    }
                }
            },
        },
        validations() {
            return {
                formData: {
                    civility: {
                        required,
                        maxLength: maxLength(20),
                    },
                    firstName: {
                        required,
                    },
                    lastName: {
                        required,
                    },
                    email: {
                        required,
                        email,
                    },
                    phoneNumber: {
                        phoneLength: phoneNumberConstraint,
                        phoneFormat: phoneNumberFormat,
                    },
                    birthDate: {
                        required,
                        validDate: validDateConstraint,
                        isValidDateYear: isValidDateYearConstraint,
                    },
                    startDate: {
                        required,
                        validDate: validDateConstraint,
                        isValidDateRange: dateInOneYearRange,
                        isValidDateYear: isValidDateYearConstraint
                    },
                },
                chosenReason: {
                    required,
                },
            };
        },
        components: {
            ConfirmationModal,
            FormError,
            MaskedInput,
            ReasonDocuments,
        }
    }
</script>
